import { useEffect, useState } from "react";
import { media } from "../../libs/media";
import {
  PrefillEmbed,
  PrefillLang,
  useCodePenEmbed,
  stripIndent
}  from 'react-codepen-prefill-embed';
import { Link, Route, useLocation, useRouteMatch } from "react-router-dom";
import CodeBoard from "../../components/codeBoard";
import { Code } from "../../libs/codeSamples";
import SimpleCodeBoard from "../../components/simpleCodeboard";
import Prism from "prismjs";
const { wordpress, github } = media.Logos.other;
const { qosLogoBlack } = media.Logos.qos;


export function NavsTabs({ options, activeStyle, notActiveStyle, mainStyle }) {
  const [active, setActive] = useState(0);
  const current = options[active];
  useEffect(() => {
    Prism.highlightAll();
  });
  return (
    <>
      <div className={mainStyle}>
        {options.map((option, index) => (
          <button
            onClick={() => setActive(index)}
            className={`${
              active === index ? activeStyle : notActiveStyle + " opacity-80"
            } p-2 transform transition-all outline-none focus:outline-none duration-500`}
            key={index + "option"}
          >
            {" "}
            {option.name}{" "}
          </button>
        ))}
      </div>
      {current.content}
    </>
  );
}

export function JsLibrary() {
  return (
    <div className="">
      <div className="bg-qosgray py-5 px-4 shadow-md mb-5 items-center w-full rounded-lg flex">
        <img src={github} alt="github" className="h-8 w-8 inline-block mr-4" />
        <a
          href="#link"
          className="text-qosblue text-msm  md:text-dsm font-bold text-opacity-70 underline"
        >
          {" "}
          clone the full code repositry here{" "}
        </a>
      </div>
      <ol className="list-decimal w-11/12 font-bold mx-auto">
        <li className="mb-2">
          <p className="font-normal font-msm md:font-dsm text-qosdark text-opacity-70">
            {" "}
            Include the file momo.bundle.js in your project
          </p>
        </li>
        <li className="mb-2">
          <p className="font-normal font-msm md:font-dsm text-qosdark text-opacity-70">
            Create a div tag at the location where you want to use the API (with
            a unique id ex: id= “momo”)
          </p>
        </li>
        <li className="mb-2">
          <p className="font-normal font-msm md:font-dsm text-qosdark text-opacity-70">
            To display the form on page, create the new instance for
            MomoControler class, see example
          </p>
          <p className="font-bold">Ex:</p>
          <CodeBoard
            modes={[
              {
                name: "JS Library sample",
                code: `var instance = new MomoControler(idDiv,clientId,username,passeword,montant,option)`,
                language: "javascript",
              },
            ]}
          />
        </li>
        <li className="mb-2">
          <p className="font-normal font-msm md:font-dsm text-qosdark text-opacity-70">
            {" "}
            The following describes the important element required to be sent
            for display for
          </p>
        </li>
      </ol>
      <table className="my-8 w-full text-msm md:text-dsm border-collapse border-qosdark">
        <thead>
          <th>Element</th>
          <th>Type</th>
          <th>Decription</th>
        </thead>
        <tbody>
          <tr>
            <td className="">idDiv</td>
            <td>
              <CodeBlock value="String:Required" />
            </td>
            <td className=""> div id </td>
          </tr>
          <tr>
            <td>clienId</td>
            <td>
              <CodeBlock value="String:Required" />
            </td>
            <td>client id</td>
          </tr>
          <tr>
            <td>username</td>
            <td className="text-qosred font-normal">
              <CodeBlock value="String:Required" />
            </td>
            <td>username </td>
          </tr>
          <tr>
            <td>password</td>
            <td>
              <CodeBlock value="String:Required" />
            </td>
            <td>client password </td>
          </tr>
          <tr>
            <td>montant</td>
            <td className="text-qosred font-normal">
              <CodeBlock value="Number:Required" />
            </td>
            <td> amount to be send</td>
          </tr>
          <tr>
            <td>option</td>
            <td className="text-qosred font-normal">
              <CodeBlock value="Object:Required" />
            </td>
            <td>
              <SimpleCodeBoard
                code={`{\n    baseDirectory:'String:required', \n    pathImage:'String:optional', \n    textIntro:'string:optional', \n    business:'string:optional' \n  }`}
                language="jq"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <CodeBoard modes={Code.Libs.javascript} />
    </div>
  );
}
export function PhpLibrary() {
  return (
    <div>
      <div className="bg-qosgray py-5 px-4 shadow-md mb-5 items-center w-full rounded-lg flex">
        <img src={github} alt="github" className="h-8 w-8 inline-block mr-4" />
        <a
          href="#link"
          className="text-qosblue text-msm  md:text-dsm font-bold text-opacity-70 underline"
        >
          {" "}
          clone the full code repositry here{" "}
        </a>
      </div>
      <CodeBoard modes={Code.Libs.php} />
    </div>
  );
}
export function DjangoLibrary() {
  return (
    <div>
      <div className="bg-qosgray py-5 px-4 shadow-md mb-5 items-center w-full rounded-lg flex">
        <img src={github} alt="github" className="h-8 w-8 inline-block mr-4" />
        <a
          href="#link"
          className="text-qosblue text-msm  md:text-dsm font-bold text-opacity-70 underline"
        >
          {" "}
          clone the full code repositry here{" "}
        </a>
      </div>
      <CodeBoard modes={Code.Libs.django} />
    </div>
  );
}
export function LaravelLibrary() {
  return (
    <div>
      <div className="bg-qosgray py-5 px-4 shadow-md mb-5 items-center w-full rounded-lg flex">
        <img src={github} alt="github" className="h-8 w-8 inline-block mr-4" />
        <a
          href="#link"
          className="text-qosblue text-msm  md:text-dsm font-bold text-opacity-70 underline"
        >
          {" "}
          clone the full code repositry here{" "}
        </a>
      </div>
      <div className="border-2 p-2 text-qosdark text-opacity-70 max-w-max border-qosred border-opacity-30 rounded-lg mb-5 text-center">
        <span className="fi fi-rr-info text-qosred text-opacity-70  inline-block mr-2"></span>
        <span>
          You need to install <b>Guzzle first</b>{" "}
        </span>
      </div>
      <CodeBoard modes={Code.Libs.laravel} />
    </div>
  );
}

export function JsPackage() {
  return (
    <div>
      <div className="border-2 p-2 text-qosdark text-opacity-70 max-w-max border-qosred border-opacity-30 rounded-lg mb-5 text-center">
        <span className="fi fi-rr-info text-qosred text-opacity-70  inline-block mr-2"></span>
        <span>
          This package can be used on nodeJS and any framework based on JS
          (ReactJS, Angular, VueJS...)
        </span>
      </div>
      <div className="bg-qosgray py-5 px-4 shadow-md mb-5 items-center w-full rounded-lg flex">
        <img src={github} alt="github" className="h-8 w-8 inline-block mr-4" />
        <a
          href="https://www.npmjs.com/package/@gurulab-co/qosic-pay-package"
          className="text-qosblue text-msm  md:text-dsm font-bold text-opacity-70 underline"
        >
          {" "}
          Go to package website
        </a>
      </div>

      {/* <CodeBoard modes={Code.Libs.laravel} /> */}
    </div>
  );
}

export function Card() {
  return (
    <div>
      <div className="border-2 p-2 text-qosdark text-opacity-70 max-w-max border-qosred border-opacity-30 rounded-lg mb-5 text-center">
        <span className="fi fi-rr-info text-qosred text-opacity-70  inline-block mr-2"></span>
        <span>
        QOS Integated Center.
        
        Sample-code-javascript-card-integration
        
        </span>
        <br/>
        <span>
        Check our github link below
        </span>
      </div>
      <div className="bg-qosgray py-5 px-4 shadow-md mb-5 items-center w-full rounded-lg flex">
        <img src={github} alt="github" className="h-8 w-8 inline-block mr-4" />
        <a
          href="https://github.com/QOS-Integated-Center/sample-code-javascript-card-integration"
          className="text-qosblue text-msm  md:text-dsm font-bold text-opacity-70 underline"
        >
          {" "}
          Go to package website
        </a>
      </div>

      {/* <CodeBoard modes={Code.Libs.laravel} /> */}
    </div>
  );
}



export function ApiDocsTogo({ Open, setOpen,Info, Infos }) {
  const [stickyDocsHeader, setSticky] = useState(false);
  useCodePenEmbed();
  const { path } = useRouteMatch();
  const { pathname } = useLocation();

  const [ pays, setPays ] = useState("Benin")


  const handleChange = (e) =>{
    setPays(e.target.value)
  }
  useEffect(() => {
    window.addEventListener("scroll", function () {
      if (window.scrollY) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    });
    document.querySelectorAll(".docslinks").forEach(
      (link) => {
        if (link.href === `${window.location.href}`) {
          link.classList.add("text-qosblue");
        } else {
          link.classList.remove("text-qosblue");
        }
      },
      [pathname]
    );
  });
  return (
    <section className="pt-10 px-6  md:px-10 lg:px-8 xl:px-8">
        <nav
        id="docsNavs"
        className={`w-50 grid  shadow-lg justify-center md:justify-start md:w-72 overflow-y-scroll md:rounded-none transform transition-all md:transform-none duration-500 md:duration-75 fixed md:left-0 px-6 top-24 md:top-px bg-qosgray rounded-md -mt-6 md:-mt-0 right-0 z-20 ${
          Open ? "translate-x-0" : "translate-x-full md:translate-x-0"
        }`}
      >
        <ul className="w-full lg:mt-24 sm:mt-0 md:mt-0">
          <Link
            onClick={() => setOpen(false)}
            to={`${path}`}
            className="py-2 md:text-dlg text-left ml-2 font-bold block docslinks"
          >
            {Infos.msg.SideOverview} 
          </Link>
          <li>
            <div className="flex h-8 py-2">
              <h4 className="md:text-dlg self-center">API Documentation</h4>
              {/* {Infos.msg.HelloText} */}
              <span className="fi fi-rr-angle-small-right"></span>
            </div>
            <p className="flex flex-col">
              <Link
                onClick={() => setOpen(false)}
                to={`${path}api`}
                className="py-1 docslinks"
              >
                Introduction
              </Link>
              <Link
                onClick={() => setOpen(false)}
                to={`${path}api/test`}
                className="py-1 docslinks"
              >
                {Infos.msg.SideProduction} 
              </Link>
              {/* <Link
                onClick={() => setOpen(false)}
                to={`${path}api/auth`}
                className="py-1 docslinks"
              >
                Authentication
              </Link> */}
              <Link
                onClick={() => setOpen(false)}
                to={`${path}api/security`}
                className="py-1 docslinks"
              >
                {Infos.msg.SideSecurity} 
              </Link>
              <Link
                onClick={() => setOpen(false)}
                to={`${path}api/payment`}
                className="py-1 docslinks"
              >
                {Infos.msg.SidePayment} 
              </Link>
              {/* <Link
                onClick={() => setOpen(false)}
                to={`${path}api/refund`}
                className="py-1 docslinks"
              >
                {Infos.msg.SideRefund} 
              </Link> */}
              <Link
                onClick={() => setOpen(false)}
                to={`${path}api/transaction`}
                className="py-1 docslinks"
              >
                {Infos.msg.SideTransaction} 
              </Link>
              <Link
                onClick={() => setOpen(false)}
                to={`${path}api/response`}
                className="py-1 docslinks"
              >
                {Infos.msg.SideResponse} 
              </Link>
            </p>
          </li>
          <li>
          <div className="flex h-8 py-2">
              <h4 className="md:text-dlg self-center">Checkout</h4>
              <span className="fi fi-rr-angle-small-right"></span>
            </div>
            <p className="flex flex-col">
              <Link
                onClick={() => setOpen(false)}
                to={`${path}checkout`}
                className="py-1 docslinks"
              >
                {Infos.msg.SideCard} 
              </Link>
             
            </p>
            <p className="flex flex-col">
              <Link
                onClick={() => setOpen(false)}
                to={`${path}checkoutstatus`}
                className="py-1 docslinks"
              >
                {Infos.msg.SideCardStatus} 
              </Link>
             
            </p>
          </li>
          <li>
            <div className="flex h-8 py-2">
              <h4 className="md:text-dlg self-center">
                Plugins and Libraries{" "}
              </h4>
              <span className="fi fi-rr-angle-small-right"></span>
            </div>
            <p className="flex flex-col">
              <Link
                onClick={() => setOpen(false)}
                to={`${path}plugins`}
                className="py-1 docslinks"
              >
                 {Infos.msg.SidePlugins} 
              </Link>
              <Link
                onClick={() => setOpen(false)}
                to={`${path}libraries`}
                className="py-1 docslinks"
              >
                Libraries
              </Link>
            </p>
          </li>
          {/* <li>
            <div className="flex h-8 py-2">
              <h4 className="md:text-dlg self-center">Tutorials</h4>
              <span className="fi fi-rr-angle-small-right"></span>
            </div>
            <p className="flex flex-col">
              <Link onClick={() => setOpen(false)} className="py-1">
                Create payment link
              </Link>
            </p>
          </li> */}
          <li className>
            <a href="https://github.com/qosintegrated/qos_discussions/discussions">
              Community
            </a>
          </li>
        </ul>
      </nav>
      <div className="md:absolute pt-14 right-4 lg:right-32 md:w-7/12 lg:w-8/12">
        <Route exact path={`${path}`}>
          <h2>Documentation</h2>
          <div>
            <p className="pt-4 tracking-widest">
            {Info.msg.Overview}
            </p>
            <img src="#none" className="hidden" alt="docsillustrtion" />
          </div>

          <div className="mt-7">
              <ol className="list-decimal ml-5 tracking-wider space-y-1">
              <li className="">Create a 
              <a href="https://dashboard.qosic.com/signup"
                      
                  className="text-justify text-qosorange mt-1.5 text-mlg font-bold"
                    > QOS account</a>,
               if you haven't already.
               </li>

               <li className="mt-1 ext-base"> {Info.msg.Etape2}
               </li>
              <li className="mt-1">{Info.msg.Etape3}
               <ul className="space-y-2">
                 <li className="mt-1">  - {Info.msg.Etape31}</li>
                 <li className="">  - {Info.msg.Etape32}</li>
                 <li className="">  - {Info.msg.Etape33}</li>
                 <li className="">  - {Info.msg.Etape34}</li>
                 <li className="">  - {Info.msg.Etape35}</li>
                 {/* <li> <span style={{fontSize:"30px"}}> &#8226;</span>  <span > Check your transaction</span></li>
                 <li> <span style={{fontSize:"30px"}}> &#8226;</span>Subscriber to New API Offer</li>
                 <li> <span style={{fontSize:"30px"}}> &#8226;</span>Make securely payout</li> */}
                  
               </ul>
             
                </li>
              <li className=""> {Info.msg.Etape4},
              <ul className="space-y-2">
                
                 <li className="mt-1">  - {Info.msg.Etape41}</li>
                 <li className="">  - {Info.msg.Etape42}</li>
                 <li className="">  - {Info.msg.Etape43}</li>
                 <li className="">  - {Info.msg.Etape44}</li>
               
                  
               </ul>
              
              </li>

              {/* <li className="">Build your integration, using one of our.
                <ul  className="space-y-1">
                  <li className="text-qosorange">  - wordpress Plugin and Libraries</li>
                </ul>
              </li>

              <li className="">Use our testing Sandbox to test before you go live..🚀
               
              </li> */}
    
              </ol>

             
        
          </div>

        </Route>
        <Route exact path={`${path}api`}>
          <h2>Introduction</h2>
          <div className="mt-7">
            <div>
              <p className="">
              {Info.msg.Introduction}
              </p>
            </div>
            <div className="mt-4">
              <div className="max-w-max">
                <span className="font-mono font-bold block text-mmd">
                  API baseUrl: MOOVTG
                </span>
                <SimpleCodeBoard
                  // code={`https://api.qosic.net/QosicBridge/user`}
                  code={`https://api.qosic.net`}
                  language="http"
                />
              </div>

              <div className="max-w-max">
                <span className="font-mono font-bold block text-mmd">
                  API baseUrl: TOGOCEL
                </span>
                <SimpleCodeBoard
                  // code={`https://api.qosic.net/QosicBridge/user`}
                  code={`https://api.qosic.net`}
                  language="http"
                />
              </div>
            </div>
         
          </div>
        </Route>
        <Route exact path={`${path}api/test`}>
         

          <div className="flex flex-row justify-between mt-8" >
            <div className=" w-50"  ><h3 className="my-1">API informations</h3></div>
          
                   
                </div>


          {/* <p className="text-xls">
            Before you move to production you need to test the QOS API on our sandbox without any risk.<br/>

          </p> */}
          <p className="text-xls">
          {Info.msg.Test}
          </p>
          {/* <p className="text-xls">
           Subscribe to TOGO API  on <a href="https://dashboard.qosic.com/"
                      
                      className="text-justify text-qosorange mt-1.5 text-mlg font-bold"
                        > Dashboard</a>, offer section to generate your API credential.
          </p> */}
          <p className="text-xls">
          {Info.msg.Test1}<br/>

          </p>

            <div>
            <h4 className="text-mdm font-normal text-opacity-80 mt-8 text-qosdark">
              Authentification informations
            </h4>
            <div className="">
              <div className="md:w-6/12">
                <p className="flex items-center mt-2">
                  <span className="font-medium text-qosdark text-opacity-80 inline-block mr-4">
                    Username:
                  </span>
                  <CodeBlock value="Your username" />
                </p>
                <p className="flex items-center mt-2">
                  <span className="font-medium text-qosdark text-opacity-80 inline-block mr-4">
                    Password:
                  </span>
                  <CodeBlock value="Your password" />
                </p>
              </div>
              <div>
                <NavsTabs
                  options={[
                    // {
                    //   name: "MTN BENIN API",
                    //   content: <MtnTestAuth index="0" />,
                    // },
                    // {
                    //   name: "MOOV BENIN API",
                    //   content: <MtnTestAuth index="1" />,
                    // },
                    {
                      name: "MOOV TOGO",
                      content: <MtnTestAuth index="2" />,
                    },
                    {
                      name: "TOGOCEL",
                      content: <MtnTestAuth index="3" />,
                    },
                  ]}
                  activeStyle="btn bg-qosorange  rounded-md py-3 px-6 scale-120 bg-opacity-80"
                  mainStyle={`p-2 flex mt-4 w-full left-0 mb-5 text-mmd md:text-dmd`}
                />
              </div>
            </div>
            <div className="flex-block ">
            <h3 className="my-4">Note</h3>
              <p className="text-xls">
              {Info.msg.Note}<br/>

              </p>
            </div>
          </div>
         
         
        </Route>
        {/* <Route exact path={`${path}api/auth`}>
          <div id="auth">
            <h2 className="font-medium">Authentication</h2>
            <p className="mb-4">
              Basic authentication is a simple authentication scheme built into
              the HTTP protocol. The client sends HTTP requests with the
              Authorization header that contains the word Basic word followed by
              a space and a base64-encoded string username:password. For
              example, to authorize as demo / p@55w0rd the client would send
            </p>
            <CodeBlock value="Authorization: Basic ZGVtbzpwQDU1dzByZA==" />
          </div>
        </Route> */}
        <Route exact path={`${path}api/security`}>
          <div id="security">
            {/* <h2 className="font-medium"></h2> */}
            {/* <h4 className="md:text-dlg self-center">Security</h4> */}
            <h2 className="my-4">Security</h2>
            <p className="space-y-3 font-light mt-6">
            {Info.msg.Security}
            </p>
          </div>
        </Route>
        <Route exact path={`${path}api/payment`}>
          <div id="payment">
            <div className="">
            <h2 className="my-4">Payment</h2>
              <p className="my-4 lg:mb-12">
              {Info.msg.Payment}
              </p>

           
             
        
           
              <div className="max-w-max space-y-2">
                <span className="font-mono font-bold block text-mmd">
                  Endpoint URI MOOVTG:
                </span>
                <SimpleCodeBoard
                  code={`POST {baseUrl}/QosicBridge/tg/v1/requestpayment`}
                  language="uri"
                />
              </div>


              <div className="max-w-max mt-3 space-y-2">
                <span className="font-mono font-bold block text-mmd">
                  Endpoint URI TOGOCEL:
                </span>
                <SimpleCodeBoard
                  code={`POST {baseUrl}/QosicBridge/tm/v1/requestpayment`}
                  // code={Code.Endpoints.payment.uritg}
                  language="uri"
                />
              </div>

              <div className="lg:flex justify-between items-center w-full">
                <div className="">
                  <table className="docs mt-4 ml-0 text-msm md:text-dsm border-collapse mb-8">
                    <thead>
                      <th>Element</th>
                      <th>Type</th>
                      <th>Decription</th>
                    </thead>
                    <tbody >
                      <tr>
                        <td className="">msisdn</td>
                        <td className="text-qosred font-normal">
                          <CodeBlock value=" string:MANDATORY " language="code" />
                        </td>
                        <td className="">Subscriber’s account i.e. 22897838872</td>
                      </tr>
                      <tr>
                        <td>amount</td>
                        <td className="text-qosred font-normal">
                          <CodeBlock value=" string:MANDATORY " language="code" />
                        </td>
                        <td>Transaction amount i.e. 5000</td>
                      </tr>
                      <tr>
                        <td>firstname</td>
                        <td className="text-qosred font-normal">
                          <CodeBlock value=" string:OPTIONAL " language="code" />
                        </td>
                        <td> Firstname of the subscriber </td>
                      </tr>
                      <tr>
                        <td>lastname</td>
                        <td className="text-qosred font-normal">
                          <CodeBlock value=" string:OPTIONAL " language="code" />
                        </td>
                        <td> Lastname of the subscriber </td>
                      </tr>
                      <tr>
                        <td>transref</td>
                        <td className="text-qosred font-normal">
                          <CodeBlock value=" string:MANDATORY " language="code" />
                        </td>
                        <td> Unique transaction reference. To be used
                        as unique identifier in call to request for a
                        payment. 
                        </td>
                      </tr>
                      <tr>
                        <td>clientid</td>
                        <td className="text-qosred font-normal">
                          <CodeBlock value=" string:MANDATORY " language="code" />
                        </td>
                        <td > A unique generated id for each third-party
                        application. This id is generated by Qos
                        and should be included in all payment
                        requests. </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="lg:-mt-20">
                  <div className="lg:flex justify-between">
                    <div className="max-w-max flex  items-center mb-2">
                      {/* <span className="fi text-qosgreen md:font-normal text-dmd inline-block mt-4  fi-rr-check"></span> */}
                      <div className="">
                        <span className="font-mono font-bold block text-mmd">
                          Succes Code
                        </span>
                        <SimpleCodeBoard
                          code={Code.Endpoints.SuccessCode}
                          language="http"
                        />
                      </div>
                    </div>
                    <div className="max-w-max flex  items-center mb-2">
                      {/* <span className="fi text-qosred md:font-normal text-dmd inline-block mt-4 fi-rr-cross"></span> */}
                      <div className="lg:ml-4 ">
                        <span className="font-mono font-bold block text-mmd">
                          Failded Code
                        </span>
                        <SimpleCodeBoard
                          code={Code.Endpoints.FailedCode}
                          language="http"
                        />
                      </div>
                    </div>
                  </div>
                  <CodeBoard modes={Code.Endpoints.paymenttg.states} />
                </div>
              </div>
       
            </div>
          </div>
        </Route>
        <Route exact path={`${path}api/refund`}>
          <div id="refund">
            <div className="">
              {/* <h2 className="mb-4 font-medium">Refund</h2> */}
              <h2 className="my-4">Refund</h2>
              <p className="mb-4">
                The Refund is a request to reverse mobile money back to the
                Subscriber’s mobile money account. Partners must code the App
                based on the API field requirements so that the App can send
                correct requests accordingly.
              </p>
              <div>
                <span className="font-mono font-bold block text-mmd">
                  Endpoint URI:
                </span>
                <SimpleCodeBoard
                  code={Code.Endpoints.refund.uri}
                  language="URI"
                />
              </div>
              <div className="justify-between items-center lg:flex">
                <div>
                  <table className="docs text-msm md:text-dsm table-fixed border-collapse mt-2 mb-8">
                    <thead>
                      <th>Element</th>
                      <th>Type</th>
                      <th>Decription</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="">transref</td>
                        <td className="text-qosred font-normal">
                          <CodeBlock value=" string:MANDATORY " language="vim" />
                        </td>
                        <td className="">The initial transaction reference used for
                          RequestPayment. This same transref
                          should be used in call to request for a
                          refund.</td>
                      </tr>
                      <tr>
                        <td>clientid</td>
                        <td className="text-qosred font-normal">
                          <CodeBlock value=" string:MANDATORY " language="vim" />
                        </td>
                        <td> A unique generated id for each third-party
                          application. This id is generated by QoS
                          and should be included in all payment
                          requests.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="justify-between">
                  <div className="lg:flex justify-between">
                    <div className="max-w-max flex mb-2 items-center mr-4">
                      {/* <span className="fi text-qosgreen md:font-normal text-dmd inline-block mt-4 fi-rr-check"></span> */}
                      <div className="">
                        <span className="font-mono font-bold block text-mmd">
                          Succes Code
                        </span>
                        <SimpleCodeBoard
                          code={Code.Endpoints.SuccessCode}
                          language="http"
                        />
                      </div>
                    </div>
                    <div className="max-w-max flex mb-2 items-center ">
                      {/* <span className="fi text-qosred md:font-normal text-dmd inline-block mt-4 fi-rr-cross"></span> */}
                      <div className="lg:ml-4">
                        <span className="font-mono font-bold block text-mmd">
                          Failded Code
                        </span>
                        <SimpleCodeBoard
                          code={Code.Endpoints.FailedCode}
                          language="http"
                        />
                      </div>
                    </div>
                  </div>
                  <CodeBoard modes={Code.Endpoints.refund.states} />
                </div>
              </div>
            </div>
          </div>
        </Route>
        <Route exact path={`${path}api/transaction`}>
          <div id="transaction">
            <div className="">
              {/* <h2 className="mb-4 font-medium">Transaction</h2> */}
              <h2 className="my-4">Transaction</h2>
              <p>
              {Info.msg.Transaction}
              </p>

            
         

            <div className="mt-10 space-y-3"> 
           
            </div>
        

              <div className="max-w-max space-y-2">
                <span className="font-mono font-bold block text-mmd">
                  Endpoint URI MOOVTG:
                </span>
                <SimpleCodeBoard
                  code={Code.Endpoints.payment.uritranstg}
                  language="uri"
                />
              
              </div>


              <div className="max-w-max mt-3 space-y-2">
                <span className="font-mono font-bold block text-mmd">
                  Endpoint URI TOGOCEL:
                </span>
                <SimpleCodeBoard
                  code={`POST {baseUrl}/QosicBridge/tm/v1/gettransactionstatus`}
                  language="uri"
                />
              </div>

              <div className="justify-between items-center lg:flex">
                <div>
                  <table className="docs text-msm md:text-dsm table-fixed border-collapse mt-2 mb-8">
                    <thead>
                      <th>Element</th>
                      <th>Type</th>
                      <th>Decription</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="">transref</td>
                        <td className="text-qosred font-normal">
                          <CodeBlock value="string:MANDATORY" language="vim" />
                        </td>
                          <td className=""> The Unique generated id provided by Qos </td>
                      </tr>
                      <tr>
                        <td>clientid</td>
                        <td className="text-qosred font-normal">
                          <CodeBlock value="string:MANDATORY" language="vim" />
                        </td>
                        <td> The transaction reference of the payment transaction  </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="justify-between">
                  <div className="lg:flex justify-between">
                    <div className="max-w-max flex justify-between items-center mb-2">
                      {/* <span className="fi text-qosgreen md:font-normal text-dmd inline-block mt-4  fi-rr-check"></span> */}
                      <div className="">
                        <span className="font-mono font-bold block text-mmd">
                          Succes Code
                        </span>
                        <SimpleCodeBoard
                          code={Code.Endpoints.SuccessCode}
                          language="http"
                        />
                      </div>
                    </div>
                    <div className="max-w-max flex  items-center mb-2">
                      {/* <span className="fi text-qosred md:font-normal text-dmd inline-block mt-4 fi-rr-cross"></span> */}
                      <div className="lg:ml-4">
                        <span className="font-mono font-bold block text-mmd">
                          Failded Code
                        </span>
                        <SimpleCodeBoard
                          code={Code.Endpoints.FailedCode}
                          language="http"
                        />
                      </div>
                    </div>
                  </div>
                  <CodeBoard modes={Code.Endpoints.transactiontg.states} />
                </div>
              </div>
            </div>
          </div>
        </Route>

        <Route exact path={`${path}api/response`}>
          <div id="response">
            <div className="">
              {/* <h2 className="mb-4 font-medium">List of response </h2> */}
              <h2 className="my-4">{Info.msg.ListofresponseTitle}</h2>
              <p>
              {Info.msg.Listofresponse} 
              </p>
              <div className="mt-4">
                <span className="font-mono font-bold block text-mmd">
                 
                </span>
                
              </div>
              <div className=" flex">
                <div className="w-full flex-inline ">
                  <table className="w-full docs text-msm md:text-dsm table-auto border-collapse mt-2 mb-8">
                    <thead>
                      <tr>
                          <th className="bg-qosorange" colspan="4">TOGO</th>
                      </tr>
                      <th >operation_type</th>
                      <th>response</th>
                      <th>response message</th>
                      <th>Explanation</th>
                    </thead>
                    <tbody>
                       
                      <tr>
                        <td className="">REQUESTPAYMENT</td>
                          <td className="">00</td>
                          <td className="">SUCCESSFUL</td>
                          <td className="">Successful response from debit</td>
                      </tr>
                      <tr>
                        <td>MAKEDEPOSIT</td>
                        <td className="">00</td>
                        <td>SUCCESSFUL </td>
                        <td className="">Successful response from credit</td>
                      </tr>
                      <tr>
                        <td>REQUESTPAYMENT</td>
                        <td className="">529</td>
                        <td>TARGET_AUTHORIZATION_ERROR</td>
                        <td className="">Low balance</td>
                      </tr>
                      <tr>
                        <td>REQUESTPAYMENT</td>
                        <td className="">527</td>
                        <td>RESOURCE_NOT_FOUND</td>
                        <td className="">Can be network issue</td>
                      </tr>
                      <tr>
                        <td >MAKEDEPOSIT</td>
                        <td className="">527</td>
                        <td>RESOURCE_NOT_FOUND</td>
                        <td className="">Can be network issue</td>
                      </tr>
                      <tr>
                        <td>REQUESTPAYMENT</td>
                        <td className="">849</td>
                        <td>The data provided in the request failed the validation check</td>
                        <td className="">Validation failed. Check request again</td>
                      </tr>
                      <tr>
                        <td>MAKEDEPOSIT</td>
                        <td className="">849</td>
                        <td>The data provided in the request failed the validation check</td>
                        <td className="">Validation failed. Check request again</td>
                      </tr>
                      <tr>
                        <td>REQUESTPAYMENT</td>
                        <td className="">515</td>
                        <td>ACCOUNTHOLDER_WITH_FRI_NOT_FOUND</td>
                        <td className="">Number from another network</td>
                      </tr>
                      <tr>
                        <td>MAKEDEPOSIT</td>
                        <td className="">682</td>
                        <td>An internal error caused the operation to fail</td>
                        <td className="">Internal Error</td>
                      </tr>
                      <tr>
                        <td>REQUESTPAYMENT</td>
                        <td className="">682</td>
                        <td>An internal error caused the operation to fail </td>
                        <td className="">Internal Error</td>
                      </tr>
                      <tr>
                        <td>REQUESTPAYMENT</td>
                        <td className="">100</td>
                        <td>Transaction couldnt be completed</td>
                        <td className="">Transaction was not completed</td>
                      </tr>
                      <tr>
                        <td>MAKEDEPOSIT</td>
                        <td className="">100</td>
                        <td>Transaction couldnt be completed</td>
                        <td className="">Transaction was not completed</td>
                      </tr>
                      <tr>
                        <td>REQUESTPAYMENT</td>
                        <td className="">1</td>
                        <td>PENDING</td>
                        <td className="">Initial response once a request is sent</td>
                      </tr>
                      
                      <tr>
                        <td>MAKEDEPOSIT</td>
                        <td className="">580</td>
                        <td>Maximum transfer amount threshold exceeded</td>
                        <td className="">Amount is larger than the receiver can receive</td>
                      </tr>
                      <tr>
                        <td>REQUESTPAYMENT</td>
                        <td className="">-1</td>
                        <td>FAILED</td>
                        <td className="">Timeout or transaction failed</td>
                      </tr>
                      
                      
                      
                    </tbody>
                  </table>


                 
                </div>
               
              </div>
            </div>
          </div>
        </Route>


        <Route exact path={`${path}checkout`}>
          <h2 className="my-2">HTML JS checkout</h2>
          <div className="mt-2">
            <div>
              <p className="">
               
              {Info.msg.Card} 


              </p>
            </div>
           
            <div className="mt-10 space-y-1"> 
            <h4> Checkout integration</h4>
              <p className="space-y-1 mt-2">
              {Info.msg.Card1} 
               
              {/* Create an account on the Qos platform and obtain Your QOSKEY by doing this few step <br/>
              First subscribe to CARD_API in offer <span className="text-qosorange" >section>offers</span> <br/>
              Secondly generate a payment Link on payment Link section <br/>
              Finally go to  <span className="text-qosorange" >Settings>privacy under ClientId column</span> to get your QOSKEY  */}
              


              </p>
            </div>

            <div className="mt-5 space-y-1"> 
            <h4>Test</h4>
              <p className="space-y-1">
               
              {Info.msg.Card2} 


              </p>
            </div>
            <div className=" mt-4 space-y-5">
              <div className="max-w-max">
                <span className="font-mono font-bold block text-mmd">
                  Test QosKey:
                </span>
                <SimpleCodeBoard
                  // code={`https://api.qosic.net/QosicBridge/user`}
                  code={`QCBJ001`}
                  
                />
              </div>

              <div className="">
              <div className="max-w-max">
                <span className="font-mono font-bold block text-mmd">
                 Card Information For Test:
                </span>
                <SimpleCodeBoard
                  // code={`https://api.qosic.net/QosicBridge/user`}
                  code={`Number: 4456530000001096 date: 12/25   CCV: 123`}
                  
                />
              </div>
            </div>

            <div className="">
              <div className="max-w-max">
                <span className="font-mono font-bold block text-mmd">
                Url for Test:
                </span>
                <SimpleCodeBoard
                  // code={`https://api.qosic.net/QosicBridge/user`}
                  code={`http://74.208.84.251:9014/public/v1/initTransaction`}
                  
                />
              </div>
            </div>
            </div>


            <div className="mt-10 space-y-1"> 
            <h4>Production</h4>
              <p className="space-y-1">
              {Info.msg.Card3} 
               
              {/* On production you will need your QosKey on  <span className="text-qosorange" >Settings>privacy under ClientId column </span> 
              and <span className="text-qosorange" > production URL</span> */}


              </p>
            </div>

            <div className="flex mt-4 space-x-5">

            <div className="">
              <div className="max-w-max">
                <span className="font-mono font-bold block text-mmd">
                Url for Prod:
                </span>
                <SimpleCodeBoard
                  // code={`https://api.qosic.net/QosicBridge/user`}
                  code={`https://b-card.qosic.net/public/v1/initTransaction`}
                  
                />
              </div>
            </div>
            </div>
          

            <div className="mt-10 space-y-1"> 
            <h4>An example</h4>
              <p className="space-y-1">
               
              {Info.msg.Card4} 
              </p>
            </div>
            <div className="mt-10">
            <PrefillEmbed
      className="codepen"
      penTitle="My sweet demo"
      embedHeight="570"
      themeId="31205"
      editable
      description="Renders a barebones React component"
      tags={['react', 'react-docs-demo']}
      htmlClasses={['loading', 'no-js']}
      head={
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      }
      scripts={[
        'https://unpkg.com/react@16.8.6/umd/react.development.js',
        'https://unpkg.com/react-dom@16.8.6/umd/react-dom.development.js',
      ]}
      stylesheets={['https://unpkg.com/normalize.css@8.0.1/normalize.css', ]}
    >
      <PrefillLang lang="html">
        {stripIndent`
        
            <!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">
    <title>Demo Checkout</title>
</head>

<body>
<div class="constainer p-3" >
<h1 class="p-2">Demo Checkout</h1>
<p class="p-2">
    Payer 100 FCFA
</p>
<button onclick="sendRequest()" id="payButton "  type="button" class="btn btn-primary">Pay Now</button>
</div>
   

    <script>

        function sendRequest() {

            // initiale body for request  ==> m = mandatory = obligatoire
            var data = {
                "type": "all", // in checkout value is mobile/card/all ==> m
                "transref": new Date().getTime(), // transref ===> m et unique
                "qosKey": "QCBJ137", // is provided by qos platform  ==> m
                "returnUrl": "https://www.qosic.com", // is callback redirection with parameter transref ans status ==> m
                "amountDetails": {
                    "totalAmount": 100, // amount wil be pay by customer //  ==> m
                    "currency": "XOF"
                },
                "saleDetails": {
                    "firstName": "jac", // m
                    "lastName": "Djac", // m
                    "middleName": "KJ",
                    "nameSuffix": "jac",
                    "title": "Mr",  // m
                    "address1": "Cotonou", // m
                    "address2": "Cococodji",
                    "address4": "string",
                    "locality": "Litoral",   // m
                    "administrativeArea": "",
                    "postalCode": "229",  // m
                    "country": "Benin",  // m
                    "district": "Bj",   // m
                    "buildingNumber": "string",
                    "email": "jacques@qosic.com",  // m
                    "emailDomain": "string",
                    "phoneNumber": "66895585",   // m
                    "phoneType": "cel"  // m
                }
            }

            fetch("https://b-card.qosic.net/public/v1/initTransaction", {
            // fetch("http://localhost:9011/public/v1/initTransaction", {
            //fetch("https://b-checkout-api.qosic.net/public/v1/initTransaction", {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            })
             .then(response => response.json())
            .then(res => {console.log(res)

                window.location.href = res.url
                
                // console.log("Request complete! response:", res);
            }); 

            /*  var xhr = new XMLHttpRequest();
             xhr.open("POST", 'https://b-checkout-api.qosic.net/public/v1/initTransaction', true);
             xhr.setRequestHeader('Content-Type', 'application/json');
             xhr.onreadystatechange = function () {
                 if (this.readyState != 4) return;
 
                 if (this.status == 200) {
                     var data = JSON.parse(this.responseText);
                     console.log(data)
 
                     // we get the returned data
                 }
 
                 // end of state change: it can be after some time (async)
             };
             xhr.send(JSON.stringify({
                 value: data
             })); */

        }




    </script>

</body>

</html>
   
        `}
      </PrefillLang>
      {/* <PrefillLang lang="scss">
        {stripIndent`
            $bg: #eee;
            body {
              background: $bg; 
            }
        `}
      </PrefillLang> */}
      {/* <PrefillLang lang="babel">
        {stripIndent`
         
          ReactDOM.render(
           
            document.getElementById('root')
          );
        `}
      </PrefillLang> */}
    </PrefillEmbed>

            </div>
          </div>
        </Route>


         <Route exact path={`${path}checkoutstatus`}>
          <div id="transaction">
            <div className="">
              {/* <h2 className="mb-4 font-medium">Transaction</h2> */}
              <h2 className="my-4">Transaction</h2>
              <p>
              {Infos.msg.Transaction}
              </p>

             
            <div className="mt-4 space-y-3">
                <span className="font-mono font-bold block text-mmd">
                  Endpoint URI:
                </span>
                <SimpleCodeBoard
                  code={Code.Endpoints.Cardtransaction.uri}
                  language="URI"
                />
              </div>
              
          
            
              <div className="justify-between items-center lg:flex">
                <div>
                  <table className="docs text-msm md:text-dsm table-fixed border-collapse mt-2 mb-8">
                    <thead>
                      <th>Element</th>
                      <th>Type</th>
                      <th>Decription</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="">transref</td>
                        <td className="text-qosred font-normal">
                          <CodeBlock value="string:MANDATORY" language="vim" />
                        </td>
                          <td className="">The transaction reference of the payment transaction </td>
                      </tr>
                      <tr>
                        <td>qoskey</td>
                        <td className="text-qosred font-normal">
                          <CodeBlock value="string:MANDATORY" language="vim" />
                        </td>
                        <td> The Unique key generated id provided by Qos   </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="justify-between">
                  <div className="lg:flex justify-between">
                    <div className="max-w-max flex justify-between items-center mb-2">
                      {/* <span className="fi text-qosgreen md:font-normal text-dmd inline-block mt-4  fi-rr-check"></span> */}
                      <div className="">
                        <span className="font-mono font-bold block text-mmd">
                          Succes Code
                        </span>
                        <SimpleCodeBoard
                          code={Code.Endpoints.SuccessCode}
                          language="http"
                        />
                      </div>
                    </div>
                    <div className="max-w-max flex  items-center mb-2">
                      {/* <span className="fi text-qosred md:font-normal text-dmd inline-block mt-4 fi-rr-cross"></span> */}
                      <div className="lg:ml-4">
                        <span className="font-mono font-bold block text-mmd">
                          Failded Code
                        </span>
                        <SimpleCodeBoard
                          code={Code.Endpoints.FailedCode}
                          language="http"
                        />
                      </div>
                    </div>
                  </div>
                  <CodeBoard modes={Code.Endpoints.Cardtransaction.states} />
                </div>
              </div>

            

            </div>
          </div>
        </Route>






        <Route exact path={`${path}plugins`}>
        <section className="">
            {/* <h2 className="font-medium opacity-80 mt-5">Plugins</h2> */}
            <h2 >Plugins</h2>
            <a
              className="flex bg-qosgray w-64 md:w-65 rounded-lg shadow-md mt-4 p-2 h-16 justify-between items-center"
              href="https://fr.wordpress.org/plugins/qos-payment-gateway/"
            >
              <img
                src={wordpress}
                className="h-11 w-2/12"
                alt="pluginswordpress"
              />
              <div className="w-10/12 pl-4">
                <span className="font-medium inline-block ">
                  Wordpress plugin
                </span>
                <span className="text-small md:text-msm opacity-60 block">
                  Allow you receive money form your wordpress website
                </span>
              </div>
            </a>
            <h3 className="my-8">Integration procedure</h3>
            <ol className="list-decimal font-normal">
              <li>
                {" "}
                <h4 className="font-normal text-mH3">
                {Info.msg.Plugin1} 
                </h4>{" "}
                <img
                  src={media.Plugin.wordpress[0]}
                  className="md:max-w-screen-md mx-auto max-w-sm -ml-0 relative block my-4 "
                />
              </li>
              <li>
                {" "}
                <h4 className="font-normal text-mH3">
                {Info.msg.Plugin2} 
                </h4>{" "}
                <img
                  src={media.Plugin.wordpress[1]}
                  className="md:max-w-screen-md mx-auto max-w-sm -ml-0 relative block my-4 "
                />
              </li>
              <li>
                {" "}
                <h4 className="font-normal text-mH3">
                {Info.msg.Plugin3} 
                </h4>{" "}
                <img
                  src={media.Plugin.wordpress[2]}
                  className="md:max-w-screen-md mx-auto max-w-sm -ml-0 relative block my-4 "
                />
              </li>
              <li>
                {" "}
                <h4 className="font-normal text-mH3">
                {Info.msg.Plugin4} 
                </h4>{" "}
                <img
                  src={media.Plugin.wordpress[3]}
                  className="md:max-w-screen-md mx-auto max-w-sm -ml-0 relative block my-4 "
                />
              </li>
              <li>
                {" "}
                <h4 className="font-normal text-mH3">
                {Info.msg.Plugin5} 
                </h4>{" "}
                <img
                  src={media.Plugin.wordpress[4]}
                  className="md:max-w-screen-md mx-auto max-w-sm -ml-0 relative block my-4 "
                />
              </li>
              <li>
                {" "}
                <h4 className="font-normal text-mH3">
                {Info.msg.Plugin6} 
                </h4>{" "}
                <img
                  src={media.Plugin.wordpress[5]}
                  className="md:max-w-screen-md mx-auto max-w-sm -ml-0 relative block my-4 "
                />
              </li>
              <li>
                {" "}
                <h4 className="font-normal text-mH3"> {Info.msg.Plugin7} </h4>{" "}
                <img
                  src={media.Plugin.wordpress[6]}
                  className="md:max-w-screen-md mx-auto max-w-sm -ml-0 relative block my-4 "
                />
              </li>
              <li>
                {" "}
                <h4 className="font-normal text-mH3">
                {Info.msg.Plugin8} 
                </h4>{" "}
                <img
                  src={media.Plugin.wordpress[7]}
                  className="md:max-w-screen-md mx-auto max-w-sm -ml-0 relative block my-4 "
                />
              </li>
              {/* <li>
                {" "}
                <h4 className="font-normal text-mH3">
                  Navigate to the <strong> plug-in</strong> section on your
                  wordpress dashbaord
                </h4>{" "}
                <img
                  src={media.Plugin.wordpress[8]}
                  className="md:max-w-screen-md mx-auto max-w-sm -ml-0 relative block my-4 "
                />
              </li> */}
              <li>
                {" "}
                <h4 className="font-normal text-mH3">
                {Info.msg.Plugin9} 
                </h4>{" "}
                <img
                  src={media.Plugin.wordpress[9]}
                  className="md:max-w-screen-md mx-auto max-w-sm -ml-0 relative block my-4 "
                />
              </li>

              <li>
                {" "}
                <h4 className="font-normal text-mH3">
                {Info.msg.Plugin11} 
                </h4>{" "}
                <img
                  src={media.Plugin.wordpress[11]}
                  className="md:max-w-screen-md mx-auto max-w-sm -ml-0 relative block my-4 "
                />
              </li>

              <li>
                {" "}
                <h4 className="font-normal text-mH3"> {Info.msg.Plugin10} </h4>{" "}
                <img
                  src={media.Plugin.wordpress[10]}
                  className="md:max-w-screen-md mx-auto max-w-sm -ml-0 relative block my-4 "
                />
              </li>
            </ol>
          </section>
        </Route>


        <Route exact path={`${path}libraries`}>
        <h2 >Libraries</h2>
          <section className="min-h-screen">
            {/* <h2 className="mt-5 mb-8">Libraries</h2> */}
      
            <NavsTabs
              options={[
                { name: "PHP", content: <PhpLibrary /> },
                { name: "JAVASCRIPT", content: <JsLibrary /> },
                { name: "DJANGO", content: <DjangoLibrary /> },
                { name: "LARAVEL", content: <LaravelLibrary /> },
                {
                  name: "JS PACKAGE",
                  content: <JsPackage />,
                },
                {
                  name: "CARD",
                  content: <Card />,
                },
              ]}
              activeStyle="btn-primary scale-120 shadow-md rounded-md bg-opacity-80"
              mainStyle={`p-2 flex ${
                stickyDocsHeader &&
                "fixed md:static md:bg-opacity-0 bg-qosgray z-50 top-16"
              } w-full left-0 justify-around mb-5 text-mmd md:text-dmd mb-8`}
            />
          </section>
        </Route>
      </div>
    </section>
  );
}

export function CodeBlock({ value }) {
  return (
    <div className="text-msm">
      <pre className="font-mono max-w-full overflow-auto text-qosred text-opacity-80 inline-block p-3 bg-qosdark bg-opacity-10 rounded" style={{ fontSize: 14, }} >
        {value}
      </pre>
    </div>
  );
}

export function DevOverview() {
  return (
    <div className="py-4 grid grid-cols-2 gap-x-5 md:w-6/12">
      <Link
        className="text-msm text-center bg-qosgray bg-opacity-90 shadow block h-24 w-full mx-auto mt-4 rounded-md"
        to="/docs/api"
      >
        <div className="h-8 w-8"></div>
        API documention
      </Link>
      <Link
        className="text-msm text-center bg-qosgray bg-opacity-90 shadow block h-24 w-full mx-auto mt-4 rounded-md"
        to="/docs/plugins-and-libraries"
      >
        <div className="h-8 w-8"></div>
        plugins and libraries
      </Link>
    </div>
  );
}

export function MtnTestAuth({ index }) {
  const infos = [
    {
      clientID: "MTNTEST",
      network:'MTN BENIN',
      Requestpayment:
        "http://staging.qosic.net:9010/QosicBridge/user/requestpayment",
      GetTransactionStatus:
        "http://staging.qosic.net:9010/QosicBridge/user/gettransactionstatus",
      numeroTest: "229xxxxxxxx",
    },
    {
      clientID: "MOOVTEST",
      network:'MOOV BENIN',
      Requestpayment:
        "http://staging.qosic.net:9010/QosicBridge/user/requestpaymentmv",
      GetTransactionStatus:
        "http://staging.qosic.net:9010/QosicBridge/user/gettransactionstatus",
      numeroTest: "229xxxxxxxx",
    },
    {
      clientID2: "",
      clientID: "YOUR_CLIENTID",
      network:'MOOV TOGO',
      Requestpayment:
        "https://api.qosic.net/QosicBridge/tg/v1/requestpayment",
      GetTransactionStatus:
        "https://api.qosic.net/QosicBridge/tg/v1/gettransactionstatus",
      numeroTest: "228xxxxxxxx",
    },
    {
      clientID2: "     ",
      clientID: "YOUR_CLIENTID",
      network:'TOGOCEL TOGO',
      Requestpayment:
        "https://api.qosic.net/QosicBridge/tm/v1/requestpayment",
      GetTransactionStatus:
        "https://api.qosic.net/QosicBridge/tm/v1/gettransactionstatus",
      numeroTest: "228xxxxxxxx",
    },
    {
      clientID2: "    ",
      clientID: "YOUR_CLIENTID",
      network:'HUBCI',
      Requestpayment:
        "https://api.qosic.net/QosicBridge/ci/v1/requestpayment",
      GetTransactionStatus:
        "https://api.qosic.net/QosicBridge/ci/v1/gettransactionstatus",
      numeroTest: "225xxxxxxxx",
    },
  ]; 
  return (
    <div>
      <p className="mt-2 flex items-center">
        <span className="font-medium text-qosdark text-opacity-80 mr-4">
          ClientID:
        </span>
        {/* <CodeBlock value={infos[index].clientID} /> */}
        { index === 2 ? <CodeBlock value={infos[index].clientID2} /> : index === 3 ? <CodeBlock value={infos[index].clientID2} /> : index === 4 ? <CodeBlock value={infos[index].clientID2} /> : <CodeBlock value={infos[index].clientID} /> }
      </p>
      <p className=" mt-2">
        <span className="font-medium text-qosdark text-opacity-80 block mr-4">
          Requestpayment Endpoint:
        </span>
        <SimpleCodeBoard code={infos[index].Requestpayment} language="http" />
      </p>
      <p className="mt-2">
        <span className="font-medium text-qosdark text-opacity-80 block mr-4">
          GetTransactionStatus Endpoint:
        </span>
        <span className="mt-2 flex items-center">
        { index === 2 ||  index === 3?  <span className="font-medium text-qosdark text-opacity-80 mr-4">
          ClientID:
        </span> : "" }{ index === 2 ||  index === 3 ?  <CodeBlock value={infos[index].clientID} /> : "" } 
        </span>
       
        

        <SimpleCodeBoard
          code={infos[index].GetTransactionStatus}
          language="http"
        />
       
      </p>
      <p className="mt-2 flex text-center items-center">
        <span className="font-medium text-qosdark  text-opacity-80 block mr-4">
         {` Test number: use ${infos[index].network} phone number`} 
        </span>
        <CodeBlock   value={infos[index].numeroTest} />
      </p>
    </div>
  );
}
